require('./preGrantedCreditStepFour.scss');
require('./preGrantedCreditStepFour.override.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const get = require('lodash/object/get');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
// components
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const ContractLoanPdfViewerError = require('../../contractLoanPdfViewerError/contractLoanPdfViewerError');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// components cc
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
// constants
const { PRE_GRANTED_CREDIT_PID } = require('constants/gdprPlacementIds');
const { PRE_GRANTED_CREDIT_STANDARD, PRE_GRANTED_CREDIT_SUBTYPE, PRE_GRANTED_CREDIT_TYPE,
    OVERDRAFT_LOAN_MAILTYPE } = require('constants/index');
const { EVIDENCE_OVERDRAFT } = require('constants/flagBasedFeatures');
const {
    CONTRACT_DOCUMENT,
    INE_DOCUMENT,
    preGrantedCredit: {
        MULTI_OTP_MESSAGE_CODE,
        OPERATION_TYPE,
    },
    SERVICE_CONTRACT_FOR_PHYSICAL_PERSONS,
    YES, NO
} = require('../../../../loansConstants/index');
const { API_CENTER, API_ENTERPRISE_NUMBER } = require('constants/index');
const translationContractLoanPdfViewerINE = require("../../contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations")
// helpers
const { recordGdprClauseInteraction } = require('utilities/consentsHelper');
const { PROC_GDPR_CONSENTS_CONTRACTS, recordLink } = require('utilities/tagging');
const { getFormattedString, decimalsLength } = require('utilities/currencyHelper');
const { getMaskedAccount } = require('../../../../loansUtilities/loansHelper');
const download = require('downloadjs');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');


class preGrantedCreditStepFour extends React.Component {

    constructor(props) {
        super(props);

        this.handleCheckboxDownloadEvents = this.handleCheckboxDownloadEvents.bind(this);
        this.handleOnPrintDocument = this.handleOnPrintDocument.bind(this);
        this.handleOnDownloadDocument = this.handleOnDownloadDocument.bind(this);
        this.handleOpenPdfNewTab = this.handleOpenPdfNewTab.bind(this);
        this.handleCheckRadioButton = this.handleCheckRadioButton.bind(this);
        this.buildRadioButton = this.buildRadioButton.bind(this);
    }

    componentDidMount() {
        const { sendOverDraftSimpleEmail, getContractDraftDocument, immPreGrantedCredit, getOverdraftInitTwo } = this.props;
        const mailAPIFlag = immPreGrantedCredit.get('mailAPIFlag');
        const fileINEDocumentId = immPreGrantedCredit.get('fileINEDocumentId');
        if (immPreGrantedCredit.get('initAPIFlag') && (__CONTACT_CENTER__ && isPrintOfficeMode() || !__CONTACT_CENTER__ && !isPrintOfficeMode())) {
            getOverdraftInitTwo().then(() => {
                getContractDraftDocument(true);
            });
        }

        if (mailAPIFlag) {
            sendOverDraftSimpleEmail(OVERDRAFT_LOAN_MAILTYPE.PRECONTRACTUAL, fileINEDocumentId);
        }

    }

    handleOpenPdfNewTab() {
        const { immPreGrantedCredit } = this.props;
        const document = immPreGrantedCredit.get('fileINEDocument');
        if (document) {
            openBase64pdfInPrintWindow(document, true);
        }
    }

    handleOnPrintDocument() {
        const { immPreGrantedCredit, immFlagBasedFeatures, onPrint } = this.props;

        const document = immPreGrantedCredit.get('fileDraftDocument');

        if (document) {
            openBase64pdfInPrintWindow(document);
        }
        isPrintOfficeMode() && onPrint();

    }


    handleOnDownloadDocument() {
        const { immPreGrantedCredit } = this.props;
        let document = immPreGrantedCredit.get('fileDraftDocument');
        let documentName = "contract_draft"

        download(document, documentName, 'application/pdf');
    }

    buildHeader() {
        return (
            <header className="pre-granted-credit-step-four__header">
                <h3>
                    <FormattedText value="contractsView-confirmationLabel" />
                </h3>
            </header>
        );
    }

    buildTinTae() {
        return (
            <span>
                <span className="pre-granted-credit-step-four tin-normal"><FormattedText value="contractsView-tin" /><FormattedText value="contractSummary-pregrantedTIN" /></span>
                &nbsp;
                (<FormattedText value="contractSummary-pregrantedTAE" /> <FormattedText value="contractsView-tae" />)
            </span>
        );
    }

    buildDetails() {
        const { immAccount, immPreGrantedCredit } = this.props;
        const account = getMaskedAccount(immAccount);

        const amount = immPreGrantedCredit.get('selectedAmount');
        const formattedAmount = getFormattedString({
            amount,
            currency: immPreGrantedCredit.get('currency'),
            decimalsLength: decimalsLength(amount)
        });

        const tinTae = this.buildTinTae();

        const fields = [
            {
                title: formatText('contractsView-amountRequested'),
                bodyText: formattedAmount,
                className: 'pre-granted-credit-step-four__important-list-item'
            },
            {
                title: formatText('contractsView-associatedAccount'),
                bodyText: account,
                bodyWordBreak: false,
                information: account,
                icon: 'icon-informacion',
                tooltipPlacement: 'top',
                tooltipOffset: [0, -15]
            },
            {
                title: formatText('contractsView-tinAndTae'),
                bodyText: tinTae
            }
        ];

        const listItems = fields.map((field, index) => (
            <OKInformativeListItem
                key={`item-${index}`}
                {...field}
            />
        ));

        return (
            <OKInformativeList columns={3}>
                {listItems}
            </OKInformativeList>
        );
    }

    buildWarning() {
        return (
            <div className="pre-granted-credit-step-four__warning">
                <FormattedText
                    value="contractsView-preGrantedCreditContractWarningMessage"
                    className="pre-granted-credit-step-four__warning-text"
                />
            </div>
        )
    }

    buildConsents() {
        return (
            <OKConsents
                placementId={PRE_GRANTED_CREDIT_PID}
                handleAcceptAll={this.onGdprAcceptAll}
                handleChangeValue={this.onGdprChangeValue}
                handleDisclaimerLinkClick={this.onGdprDisclaimerLinkClick}
            />
        );
    }

    handleCheckboxDownloadEvents(docType) {
        const { immPreGrantedCredit } = this.props;
        if (docType === INE_DOCUMENT) {
            window.open(immPreGrantedCredit.get('precontractualLink'));
        } else {
            window.open(SERVICE_CONTRACT_FOR_PHYSICAL_PERSONS);
        }
    }

    buildLinkButtonMessage(docType, documentName) {
        return (
            <OKButton
                onClick={() => this.handleCheckboxDownloadEvents(docType)}
                modifier="link-emphasize"
                autoHeight
                loading={false}
            >
                {documentName}
            </OKButton>
        )
    }

    buildCheckboxLabel(poeditorPrefix) {
        const getPoEditorKey = key => {
            return `${poeditorPrefix}-${poeditorPrefix}_${key}`;
        };
        const splitMessage = formatText(getPoEditorKey(`pregrantedCreditAgreeCheckboxLabel`)).split('%s');

        const injectedLinks = [
            { docType: INE_DOCUMENT, text: getPoEditorKey('pregrantedCreditIneDocument') },
            { docType: CONTRACT_DOCUMENT, text: getPoEditorKey('pregrantedCreditContractDocument') },
        ];

        const message = splitMessage.map((message, index) => {
            const link = injectedLinks[index];
            const documentName = link ? formatText(link.text) : '';
            const replacement = link ? this.buildLinkButtonMessage(link.docType, documentName) : '';

            return (
                <span key={index}>
                    {message}
                    {replacement}
                </span>
            );
        });

        return <span>{message}</span>;
    }

    buildLegalDraftContract() {
        const { immPreGrantedCredit, getContractDraftDocument, immFlagBasedFeatures } = this.props;
        const errorLoading = immPreGrantedCredit.get('errorDraftDocument');
        const scale = 1;
        const fileDraftDocument = immPreGrantedCredit.get('fileDraftDocument');
        const DEFAULT_VIEWER_HEIGHT = 320;
        const successDraftDocument = immPreGrantedCredit.get('successDraftDocument');

        return (
            successDraftDocument ? <OKPdfViewer
                onDownload={this.handleOnDownloadDocument}
                onPrint={this.handleOnPrintDocument}
                pdfFile={fileDraftDocument}
                title={formatText(translationContractLoanPdfViewerINE.TITLE_CONTRACT_DRAFT_DOCUMENT)}
                scale={scale}
                infiniteScroll
                failedLoadingPdf={errorLoading}
                errorComponent={() => {
                    return <ContractLoanPdfViewerError
                        getDocuments={getContractDraftDocument}
                        overdraftFlag={true} />
                }}
                viewerHeight={DEFAULT_VIEWER_HEIGHT}
                onDocumentReaded={this.handleDocumentReaded}
            /> : <LoadingSection />
        );
    }

    buildOtpParams() {
        const { immPreGrantedCredit, immAccount, immFlagBasedFeatures } = this.props;
        const ammount = immPreGrantedCredit.get('selectedAmount');
        const currency = immPreGrantedCredit.get('currency');
        const operationProcessIdPolicy = immPreGrantedCredit.get('operationProcessIdPolicy')

        return immFlagBasedFeatures.get(EVIDENCE_OVERDRAFT) ? {
            ammount,
            currency,
            originAccount: API_ENTERPRISE_NUMBER + API_CENTER + immAccount.get('product') + immAccount.get('contractNumber'),
            operationProcessId: operationProcessIdPolicy,
            evidenceType: "SIGN_DOCUMENT"
        } : {
            ammount,
            currency,
            originAccount: API_ENTERPRISE_NUMBER + API_CENTER + immAccount.get('product') + immAccount.get('contractNumber')
        };
    }

    buildOtp() {
        const { immPreGrantedCredit, immFlagBasedFeatures } = this.props;
        const params = this.buildOtpParams();
        const operationProcessIdPolicy = immPreGrantedCredit.get('operationProcessIdPolicy')
        const overdrafFF = immFlagBasedFeatures.get(EVIDENCE_OVERDRAFT)

        return (
            <div className="pre-granted-credit-step-four__otp">
                <GDPRSignaturePattern
                    operationType={OPERATION_TYPE}
                    operationParams={params}
                    multiOTPMessageCode={MULTI_OTP_MESSAGE_CODE}
                    isOverDraft={true}
                    isEasyLoanTypeAB={true}
                    newOperationProcessId={overdrafFF && operationProcessIdPolicy}
                />
            </div>
        );
    }

    handleCheckRadioButton(check) {
        const { checkRadioButtonOfficeStepFour } = this.props;
        checkRadioButtonOfficeStepFour(check === YES)
    }



    onGdprAcceptAll(value) {
        recordGdprClauseInteraction(value, PROC_GDPR_CONSENTS_CONTRACTS)
    }

    onGdprChangeValue(id, value) {
        recordGdprClauseInteraction(value, PROC_GDPR_CONSENTS_CONTRACTS, id);
    }

    onGdprDisclaimerLinkClick(event) {
        const linkElement = event.target;

        if (linkElement) {
            recordLink(PROC_GDPR_CONSENTS_CONTRACTS, get(linkElement, 'attributes.data-title.value', ''));
        }
    }

    buildRadioButton() {
        const { immPreGrantedCredit } = this.props;
        const officePrintStepFour = immPreGrantedCredit.get('officePrintStepFour');
        const documentSignedRadioButton = immPreGrantedCredit.get('documentSignedRadioButtonStepFour');

        return (
            officePrintStepFour &&
            <div className="mortgage-request-holder-radio-button">
                <p>{formatText(`hireCardtStep-titleOfficeRadio`)}</p>
                <RadioButtonGroup
                    onChange={this.handleCheckRadioButton}
                    selectedValue={documentSignedRadioButton === null ? '' : documentSignedRadioButton ? YES : NO}
                    idPrefix="newRadioPrintedDocument"
                    isHorizontal={false}
                    name="newRadioPrintedDocument">
                    <RadioButton label={formatText('officePrinter-yesRadioOption')} value={YES} className="signature-pattern__printed-documents-radio" />
                    <RadioButton label={formatText('officePrinter-noRadioOption')} value={NO} className="signature-pattern__printed-documents-radio" />
                </RadioButtonGroup>
            </div>
        )
    }

    render() {
        const { immFlagBasedFeatures, immPreGrantedCredit } = this.props;
        const header = this.buildHeader();
        const warning = this.buildWarning();
        const details = this.buildDetails();
        const consents = this.buildConsents();
        const isWebwithOverdraftProtection = isPrintOfficeMode() || !__CONTACT_CENTER__;
        const otp = this.buildOtp();
        const documentViewSection = isWebwithOverdraftProtection ? this.buildLegalDraftContract() : null;
        const operative = formatText('operatives-loansAndMortgageHire_preGrantedCredit');

        return (<article className="pre-granted-credit-step-four">
            {header}
            <section className="pre-granted-credit-step-four__section">
                {
                    !isPrintOfficeMode() && <ConfirmationScript isOverDraft operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                }
                {warning}
                {details}
                {consents}

            </section>
            {
                !isPrintOfficeMode() && <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
            }
            <div>
                <h4 className="contract-loan-pdf-viewer__subtitle">
                    <strong>
                        <FormattedText value={translationContractLoanPdfViewerINE.SUBTITLE_CONFIRM_PAGE} />
                    </strong>
                </h4>
                <div className="contract-actions-readed">
                    <button className="link--red" onClick={() => this.handleOpenPdfNewTab()}>
                        <FormattedText value={translationContractLoanPdfViewerINE.OVERDRAFT_TEXT_CONFIRM_PAGE} />
                    </button>
                    <span><i className="signature-pattern-code-input__icon icon icon-check" />
                        <FormattedText className="signature-text" value={translationContractLoanPdfViewerINE.LEGAL_INFO_READ_BUTTON} />
                    </span>
                </div>
                <div className="contract-loan-step-four__informative-text" style={{ "margin": "15px 0" }}>
                    <FormattedText value={translationContractLoanPdfViewerINE.OVERDRAFT_SUBTITLE_STEP4} />
                </div>
            </div>
            {isPrintOfficeMode() &&
                <BlockInfo>
                    <FormattedText value={'contractsView-preGrantedCreditContractOfficeMessage2'} />
                </BlockInfo>
            }
            <div style={{ "margin": "15px 0" }}>
                {documentViewSection}
            </div>
            {this.buildRadioButton()}
            {otp}
        </article>)
    }
}

preGrantedCreditStepFour.propTypes = {
    getHiringDocuments: PropTypes.func.isRequired,
    getOverdraftInitOne: PropTypes.func.isRequired,
    immAccount: PropTypes.object,
    immPreGrantedCredit: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    onAgreeCheckbox: PropTypes.func.isRequired,
    onAgreeReset: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    onPrint: PropTypes.func.isRequired,
    sendOverDraftSimpleEmail: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    updateConfirmationCheckbox: PropTypes.func.isRequired,
    getINEDocument: PropTypes.func.isRequired,
    getContractDraftDocument: PropTypes.func.isRequired,
    checkRadioButtonOfficeStepFour: PropTypes.func.isRequired,
}

module.exports = preGrantedCreditStepFour;
